module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vcirc2-49e78a6e0375abefaac415215a2823fd.jpg";